export enum TipoPlanoRede {
    Plano = 'plano',
    Rede = 'rede'
}
